import React from "react";

export const SafeExchange = () => (
    <section className="panel" data-testid="safe-exchange">
        <div className="px-6 sm:px-8 py-5 border-b hairline">
            <p className="mono-label">Secondary route</p>
            <h2
                className="font-serif mt-1"
                style={{ fontSize: 26, letterSpacing: "-0.01em" }}
            >
                Safe pharma & research signal exchange
            </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3">
            <div className="px-6 sm:px-8 py-5 lg:border-r hairline">
                <p className="mono-label">Position</p>
                <p
                    className="mt-3 font-serif"
                    style={{ fontSize: 15.5, lineHeight: 1.55 }}
                >
                    Pharma / research receives a consented, bounded signal or
                    aggregate reference — not the full patient record.
                </p>
            </div>
            <div className="px-6 sm:px-8 py-5 lg:border-r hairline">
                <p className="mono-label">Possible exchanges</p>
                <ul className="mt-3 space-y-2" style={{ fontSize: 14 }}>
                    <li>· Safety signal reference</li>
                    <li>· Adverse trend category</li>
                    <li>· Cohort eligibility flag</li>
                    <li>· Consented research participation status</li>
                    <li>· Medication review outcome</li>
                </ul>
            </div>
            <div className="px-6 sm:px-8 py-5">
                <p className="mono-label">Boundary</p>
                <p className="mt-3" style={{ fontSize: 14, color: "var(--ink-soft)" }}>
                    No raw streams, no full record, no identifiers. Every exchange
                    leaves a signed KATLAS receipt at source.
                </p>
            </div>
        </div>
    </section>
);

export default SafeExchange;
